import * as React from 'react';
import { getSettings, getFestivalSeries } from '../../redux/actions/festival-overview-api';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import DayItemComponent from './day-nav-item';
import { FestivalOverviewAppState } from '../../classes/redux-states';
import MobileDayComponent from './day-nav-mobile';

interface StateToProps {
	dayList: string[];
	activeDay: string;
}

export class DayListComponent extends React.Component<StateToProps, null> {
	constructor(props: StateToProps) {
		super(props);
        this.isActiveDay = this.isActiveDay.bind(this);

	}

	isActiveDay(dayName: string) {
		if (dayName == this.props.activeDay) return true;
		else return false;
	}
	

	render() {
		return (
			<div className="season-overview-navigation" role="navigation">
				<div className="season-overview-navigation-container season-overview-navigation-desktop">
					{this.props.dayList.map((day) => (
						<DayItemComponent
							dayName={day}
							key={this.props.dayList.indexOf(day)}
							active={this.isActiveDay(day)}
						/>
					))}
					
				</div>
					<MobileDayComponent />
			</div>
		);
	}
}

function mapStateToProps(state: FestivalOverviewAppState): StateToProps {
	return {
		dayList: state.festivalOverviewSettingsModel.dayList,
		activeDay: state.festivalOverviewApiModel.currentDay
	};
}

export default connect(mapStateToProps, null)(DayListComponent);
